import ReactDOM from "react-dom";
import React from "react";

function formatDate(value) {
  if (!value) return "—";
  return new Date(value).toLocaleString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/**
 * UserInfoModal — même format que ModalFiche (Recherche) : header titre +
 * croix, body avec les métadonnées, footer "Fermer".
 *
 * Usage :
 *   <UserInfoModal user={selectedUser} onClose={() => setSelectedUser(null)} />
 */
export function UserInfoModal({ user, onClose }) {
  if (!user) return null;

  return ReactDOM.createPortal(
    <>
      <div
        className="modal modal-blur fade show d-block"
        tabIndex="-1"
        role="dialog"
        style={{ zIndex: 2000 }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">

            {/* HEADER */}
            <div className="modal-header">
              <h5 className="modal-title">{user.utcNom}</h5>
              <button type="button" className="btn-close" onClick={onClose} />
            </div>

            {/* BODY */}
            <div className="modal-body">
              <div className="text-end text-muted small mb-3">
                {user.utcMail}<br />
                {user.comLib}
              </div>

              <div><i>Date de création :</i> {formatDate(user.utcDateCreation)}</div>
              <div><i>Dernière Modification :</i> {formatDate(user.utcDateModification)}</div>
              <div><i>Dernière connexion :</i> {formatDate(user.utcDerniereConnexion)}</div>
              <div><i>Nb connexions :</i> {user.utcNbConnexion ?? 0}</div>
            </div>

            {/* FOOTER */}
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Fermer
              </button>
            </div>

          </div>
        </div>
      </div>

      {/* BACKDROP */}
      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1999 }}
        onClick={onClose}
      />
    </>,
    document.body
  );
}
